<template>
  <div style="background: #CDC7BA">
    <van-loading type="spinner" v-if="nodata"/>
    <div v-if="dominItem.templateId === 'temp3'">
      <div class="logo" style="display: flex;justify-content: space-between; align-items: center; padding-left: 10%"
           :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">
        <span>{{ dominItem.logoName || 'Logo' }}</span>
        <span style="font-size: 18px">{{ nowDate }}</span></div>
      <div class="category" :class="`${dominItem.templateId}`">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
      </div>
    </div>

    <div v-else>
      <div class="logo" style="display: flex;justify-content: space-between; align-items: center; padding: 10px 10%" :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">
        <span style="font-size: 18px">{{ nowDate }}</span><span>{{ dominItem.logoName || 'Logo' }}</span></div>
      <div class="category" :class="`${dominItem.templateId}`">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
      </div>
    </div>
    <div style="padding: 0 10%;">
      <div class="opinion-artists-models-page">
        <div class="artists-section">
          <h2 class="section-title">{{ $t('con_latest') }}</h2>
          <div class="artists-content">
            <div class="artists-article-list">
              <div
                  v-for="(item, index) in recommendList2"
                  @click="toDetail(item.articleShortName)"
                  :key="index"
                  class="artist-article"
              >
                <img :src="item.articleImage" class="artist-img" />
                <div style="display:flex; flex-direction: column">
                  <h3 class="artist-title twoHde">{{ item.articleTitle }}</h3>
                  <h3 style="font-size: 13px; color: #888; font-weight: 400" class="threeHde">{{ item.articleIntro }}</h3>
                </div>
              </div>
            </div>
            <div class="featured-artist" @click="toDetail(bestItem.articleShortName)">
              <img
                  :src="bestItem.articleImage"
                  class="featured-artist-img"
              />
              <h3 class="featured-artist-title twoHde">{{ bestItem.articleTitle }}</h3>
              <p class="featured-artist-desc threeHde">
                {{ bestItem.articleIntro }}
              </p>
            </div>
          </div>
        </div>
        <!-- OPINION 板块 -->
        <div class="opinion-section">
          <h2 class="section-title">{{ $t('con_recommended') }}</h2>
          <div
              v-for="(item, index) in articleList"
              :key="index"
              @click="toDetail(item.articleShortName)"
              class="opinion-article"
          >
            <img :src="item.articleImage" class="opinion-img" />
            <div class="opinion-text">
              <h3 class="opinion-title twoHde">{{ item.articleTitle }}</h3>
              <p class="opinion-desc threeHde">{{ item.articleIntro }}</p>
            </div>
          </div>
        </div>
        <!-- ARTISTS 板块 -->

        <!-- MODELS 板块 -->
        <div class="models-section">
          <h2 class="section-title">{{ $t('con_hot_con') }}</h2>
          <div class="models-grid">
            <div
                v-for="(item, index) in latestNewsList"
                @click="toDetail(item.articleShortName)"
                :key="index"
                class="model-article"
            >
              <img :src="item.articleImage" class="model-img" />
              <h3 class="model-title threeHde">{{ item.articleTitle }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="buttom">
      <div style="display: flex; flex-direction: column; width: 100%; padding: 0 10%">
        <div class="logo">{{ dominItem.logoName || 'Logo' }}</div>
        <div class="explore">
          <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer">{{ item.label }}</span>
        </div>
        <div class="img"  v-if="dominItem.nationId !== 'cn'">
          <img  v-for="item in iconListsmall" @click="openLink(item.link)" :src="item.url">
        </div>
      </div>
      <div class="content1">
        <span class="oneHde" @click="toDetail(item.articleShortName)"  v-for="item in articleListlast">● {{item.articleTitle}}</span>
      </div>

    </div>
  </div>
</template>

<script>
import topIcon from '../../icons/small.vue'
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"
import {format} from "date-fns";
import {getContentList, getLatestNews, getOne, getRecommend} from "@/api";


export default {
  components: {topIcon, buttomIcon, footers},
  props: {
    dominItem: Object
  },
  name: "index",
  data() {
    return {
      bestItem: {},
      recommendList1: [],
      latestNewsList:[],
      articleList: [],
      articleListlast:[],
      recommendList:[],
      latestNewsList1:[],
      recommendList2:[],

      nowDate: undefined,
      nodata: false,
      template: 'temp1',
      current: 1,
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_about'), id: 8},
      ],
    }
  },
  created() {
    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    }else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getLatestNewsList1()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
this.nowDate = format(new Date(), this.$t('con_format'))
  },

  methods: {
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getLatestNewsList1()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    openLink(link) {
      window.open(link)
    },

// 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
          if (!res.data.articleImage) {
            res.data.articleImage = require('@/assets/defore.jpg')
          }
        this.bestItem = res.data
      })
    },

    // 获取文章列表
    getArticleList() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: this.newsPageNum, pageSize: 6, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows
        this.nodata = false
      })
    },

    // 获取最下面文章列表
    getArticleListlast() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: 3, pageSize: 6, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    // 获取最后更新的文章
    getLatestNewsList() {
      getLatestNews({articleCategoryId: this.current, pageNum: this.newsPageNum, pageSize: 8, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.latestNewsList = res.rows
        this.newsTotal = res.total
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList1() {
      getLatestNews({articleCategoryId: this.current, pageNum: 2, pageSize: 2, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.latestNewsList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取推荐的文章
    getRecommendList() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 4, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList = res.rows
      })
    },

    getRecommendList1() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 8, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList1 = res.rows
      })
    },

    getRecommendList2() {
      getRecommend({articleCategoryId: this.current, pageNum: 2, pageSize: 4, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList2 = res.rows
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">

.content1 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  span{
    display: inline-block;
    margin-bottom: 10px;
    color: #ffffff;
    width: 600px;

    font-size: 16px;
  }
}

.opinion-artists-models-page {
  padding: 20px;

  .section-title {
    border-bottom: 6px solid #FFCE0D;
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;
  }

  // OPINION 板块样式
  .opinion-section {
    margin-bottom: 30px;

    .opinion-article {
      display: flex;
      gap: 10px;
      margin-bottom: 15px;

      .opinion-img {
        width:160px;
        height: 120px;
        object-fit: cover;
      }

      .opinion-text {
        .opinion-title {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 5px;
        }

        .opinion-desc {
          font-size: 15px;
          color: #666;
          line-height: 1.4;
        }
      }
    }
  }

  // ARTISTS 板块样式
  .artists-section {
    margin-bottom: 30px;
    // 黄色分隔线，贴合参考样式
    padding-top: 15px;

    .artists-content {
      display: flex;
      gap: 20px;

      .artists-article-list {
        width: 30%;

        .artist-article {
          display: flex;
          gap: 10px;
          margin-bottom: 15px;

          .artist-img {
            width: 160px;
            height: 120px;
            object-fit: cover;
          }

          .artist-title {
            font-size: 16px;
            font-weight: bold;
            align-self: center;
            margin-bottom: 10px;
          }
        }
      }

      .featured-artist {
        width: 70%;

        .featured-artist-img {
          width: 100%;
          height: 400px;
          object-fit: cover;
          margin-bottom: 10px;
        }

        .featured-artist-title {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 10px;
        }

        .featured-artist-desc {
          font-size: 15px;
          color: #666;
          line-height: 1.4;
        }
      }
    }
  }

  // MODELS 板块样式
  .models-section {
    // 黄色分隔线，贴合参考样式
    padding-top: 15px;

    .models-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 15px;

      .model-article {
        .model-img {
          width: 100%;
          height: 150px;
          object-fit: cover;
          margin-bottom: 10px;
        }

        .model-title {
          font-size: 15px;
          font-weight: bold;
          text-align: center;
        }
      }
    }
  }
}

.logo {
  //width: 100%;
  //padding: 10px 10%;
  padding: 10px 0;
  background: #141414;
  box-sizing: border-box;
  font-size: 40px;
  color: #E0DAC8;
  font-weight: bold;
  text-align: left;
  border-bottom: 1px solid #fff ;
}

.logo-temp1 {
  text-align: center;
}

.logo-temp2 {
  text-align: left;
}

.category {
  width: 100%;
  padding: 0 10%;
  min-height: 50px;
  background: #FFFFFF;
  margin-bottom: 30px;
  color: #141414;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid var(--themeColor);
  line-height: 48px;

  span {
    font-weight: 700;
    font-size: 14px;
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
  }

  span:hover {
    //border-bottom: 3px solid red;
    color: #000;
    transition: all .5s ease;
  }

  .choose {
    //border-bottom: 3px solid red;
    transition: all .1s ease;
    color:#000;
  }
}

.buttom {
  border-top: 5px solid #141414;
  background: #141414;
  display: flex;
  align-items: center;
  justify-content: center;

  .logo{
    border: none;
    text-align: center;
  }

  display: flex;

  .explore {
    margin: 10px 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    span {
      margin-right: 10px;
      font-size: 15px;
      width: 200px;
      display: inline-block;
      color: #E0DAC8;
      text-align: center;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #092647;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  padding: 0 10% 20px;
  display: flex;
  flex-wrap: wrap;
  span{
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.small-title {
  font-size: 13px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-left: 10px;
}

.small {
  font-size: 12px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin-left: 10px;
  -webkit-line-clamp: 3;
}
.img {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 30px;
  margin-bottom: 30px;
  img{
  width: 30px;
  height: 30px;
}

  img:nth-child(3) {
    width: 40px;
    height: 40px;
  } img:nth-child(4) {
    width: 40px;
    height: 40px;
  }
  img:nth-child(5) {
    width: 40px;
    height: 40px;
  }
}
.temp1{
  padding-left: 10%;
}
.temp3{
  padding-right: 10%;
}
</style>